<template>
  <div>
    <v-row class="d-flex justify-sm-end">
      <v-col cols="12" sm="6" lg="3">
        <v-btn color="primary" outlined :to="`/manage/forms/${operation.object_type}/${operation.form_name}/${operation.id}`">
          {{ $t("button.see.originalForm") }}
        </v-btn>
      </v-col>
      <v-col v-if="operation.object_id" cols="12" sm="6" lg="3">
        <v-btn color="purple" outlined :to="`/manage/edit/datasets/edit/${operation.object_id}`">
          {{ $t("button.see.editObject") }}
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col cols="6" sm="3" md="2"><FinishFormSwitch :item="operation" /></v-col>
      <v-col cols="6" sm="3" md="3" lg="2"><ProcessingCommentDialog :moderated-operation="operation" /></v-col>
    </v-row>
    <v-card v-if="operation.data" class="pa-6 mb-4">
      <DatasetFields :dataset="dataset" :editor-ready="true" readonly />
    </v-card>
    <ProcessFormActions :item="operation" @item-processed="handleProcessed" />
  </div>
</template>
<script>
import axios from "axios";
import DatasetFields from "@/components/datasets/DatasetFields.vue";
import FinishFormSwitch from "@/components/reusables/FinishFormSwitch";
import ProcessFormActions from "@/components/action_buttons/ProcessFormActions";
import ProcessingCommentDialog from "@/components/reusables/ProcessingCommentDialog";
import { createDefaultDataset, normalizeDataset } from "@/utils/dataset";

export default {
  name: "ProcessDataset",
  components: { DatasetFields, FinishFormSwitch, ProcessFormActions, ProcessingCommentDialog },
  data: () => ({ operation: {}, dataset: createDefaultDataset() }),
  created() {
    axios.get(`${this.$store.state.endpoint}/moderatedOperations/review/dataset/${this.$route.params.id}`)
      .then(response => {
        this.operation = response.data;
        this.dataset = normalizeDataset(response.data.data.user.dataset);
      }).catch(error => console.error(error));
  },
  methods: {
    handleProcessed(item) { this.operation.state = item.state; this.operation.object_id = item.object_id; }
  }
};
</script>
